/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './HouseholdList.module.scss'
import { useHistory } from 'react-router-dom'
import AddHouseholdMemberView from './AddHouseholdMemberView'
import HouseholdListTable from './HouseholdListTable'
import { useDispatch, useSelector } from 'react-redux'
import BackAnchor from 'shared/components/BackAnchor'
import { setEditNSIdentifierNumber } from 'redux/actions';

const HouseholdListView = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const dispatch = useDispatch();
  const { jointlyRegistered, registeredBusiness } = useSelector((state) => state.app.addressTypeChange);
  const { editNSIdentifierNumber } = useSelector((state) => state.app.personalInformation);
  const onNextClick = () => {
    if (jointlyRegistered) {
      history.push(`/${i18n.language}${t('routes.jointly_owned_vehicle_info')}`)
    } else if (registeredBusiness) {

      history.push(`/${i18n.language}${t('routes.business_vehicle_info')}`)
    } else {

      history.push(`/${i18n.language}${t('routes.addresses_to_change')}`)
    }
  }

  const onBackClick = () => {
    dispatch(setEditNSIdentifierNumber(editNSIdentifierNumber));
  }

  return (
    <div>
      <div className="container">
        <div className="row">
          <BackAnchor onBackClick={onBackClick} />
        </div>
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <h1>{t('household_list.title')}</h1>
          </div>
        </div>
        <HouseholdListTable setIsError={setIsError} />
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <button
              className={['btn-lg btn-default', styles['next_button']].join(' ')}
              onClick={onNextClick}
              value={t('household_list.next')}
              name={t('household_list.next')}
            >
              {t('household_list.next')}
            </button>
          </div>

        </div>
        <div>
          <AddHouseholdMemberView t={t} setIsError={setIsError} />
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(HouseholdListView)
